"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ssrWindow = require("ssr-window");
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _dayjs = _interopRequireDefault(require("../utils/dayjs"));
const splitTextDate = (date, delimeter) => {
  const d = date.split(delimeter);
  return new Date(d[2], d[0] - 1, d[1]);
};
const splitMobileDate = date => {
  const d = date.split('-');
  return new Date(d[0], d[1] - 1, d[2]);
};

/**
 * Utilities for working with dates.
 * @module DateUtils
 */
const DateUtils = {
  /**
   * Check whether input type of 'date' is supported in the current browser.
   * @static
   * @function supportsDateInput
   * @example
   * DateUtils.supportsDateInput();
   * @returns {Boolean} - Whether the input type is supported.
   */
  supportsDateInput() {
    const fakeValue = 'not-a-date';
    const input = document.createElement('input');
    input.setAttribute('type', 'date');
    input.setAttribute('value', fakeValue);
    return input.value !== fakeValue;
  },
  /**
   * Gets the closest match to the user's current time zone.
   * @static
   * @function getTimeZone
   * @example
   * DateUtils.getTimeZone(); // 'America/Chicago'
   * @returns {String} - The user's current time zone.
   */
  getTimeZone() {
    if (_ssrWindow.window.Intl && (0, _isObject.default)(_ssrWindow.window.Intl) && _ssrWindow.window.Intl.DateTimeFormat().resolvedOptions().timeZone) {
      return _ssrWindow.window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else {
      return _dayjs.default.tz.guess();
    }
  },
  /**
   * Converts a mobile input date to a string using the specified format.
   * @static
   * @function convertToDesktop
   * @param {String} date - The input value in the format YYYY-MM-DD.
   * @param {String} [format='MM/DD/YYYY'] - The output format.
   * @example
   * DateUtils.convertToDesktop('1983-01-19');
   * @returns {String} - The formatted date.
   */
  convertToDesktop(date, format = 'MM/DD/YYYY') {
    if (!(0, _isString.default)(date)) {
      throw new Error('The supplied date is not a string.');
    }
    if (date.indexOf('-') !== -1) {
      return (0, _dayjs.default)(splitMobileDate(date)).format(format);
    } else {
      return date;
    }
  },
  /**
   * Converts a desktop input date to the native mobile date format.
   * @static
   * @function convertToMobile
   * @param {String} date - The input value in the format MM/DD/YYYY.
   * @example
   * DateUtils.convertToMobile('01/19/1983');
   * @returns {String} - The mobile formatted date.
   */
  convertToMobile(date) {
    if (!(0, _isString.default)(date)) {
      throw new Error('The supplied date is not a string.');
    }
    if (date.indexOf('/') !== -1) {
      return (0, _dayjs.default)(splitTextDate(date, '/')).format('YYYY-MM-DD');
    } else {
      return date;
    }
  },
  /**
   * Converts a string date from a text or date input to a date object.
   * @static
   * @function getAsDate
   * @param {String} date - The date in the format MM/DD/YYYY (text input) or YYYY-MM-DD (date input).
   * @example
   * DateUtils.getAsDate('1983-01-19');
   * DateUtils.getAsDate('01/19/1983');
   * @returns {Date} - The date object.
   */
  getAsDate(date) {
    if (!(0, _isString.default)(date)) {
      throw new Error('The supplied date is not a string.');
    }
    if (date.indexOf('-') !== -1) {
      // date input
      return splitMobileDate(date);
    } else {
      // text input
      return splitTextDate(date, '/');
    }
  },
  /**
   * Converts a string date from a text or date input to a day instance.
   * @static
   * @function getAsDay
   * @param {String} date - The date in the format MM/DD/YYYY (text input) or YYYY-MM-DD (date input).
   * @example
   * DateUtils.getAsDayjs('1983-01-19');
   * DateUtils.getAsDayjs('01/19/1983');
   * @returns {Dayjs} - The day instance.
   */
  getAsDayjs(date) {
    if (!(0, _isString.default)(date)) {
      throw new Error('The supplied date is not a string.');
    }
    if (date.indexOf('-') !== -1) {
      // date input
      return (0, _dayjs.default)(splitMobileDate(date));
    } else {
      // text input
      return (0, _dayjs.default)(splitTextDate(date, '/'));
    }
  },
  /**
   * Combines a date with a time to return one day instance.
   * @static
   * @function combineDateAndTime
   * @param {Dayjs} date - The date as a day instance.
   * @param {Dayjs} time - The time as a day instance.
   * @example
   * DateUtils.combineDateAndTime(day(), day().add(7, 'hours').add(23, 'minutes'));
   * @returns {Dayjs} - The combined day instance.
   */
  combineDateAndTime(date, time) {
    if (!_dayjs.default.isDayjs(date) || !_dayjs.default.isDayjs(time)) {
      throw new Error('The date and/or time supplied was not an instance of dayjs.');
    }
    return date.hour(time.hour()).minute(time.minute());
  }
};
var _default = exports.default = DateUtils;